import styled from 'styled-components';

import { generateFluidPxScale } from '@/components/blog-2/utils';

/**
 * Layout Grid used to set number of columns in content area.
 * default columns are 12. Gutter/gap should always be 0.
 * Try to keep columns to a multiple of 4.
 */
export const LayoutGrid = styled.div<{ columns?: number }>`
  --columns: ${({ columns }) => columns || 12};
  --content-width: min(96%, ${({ theme }) => theme.maxWidth.GRID_CONTENT});
  --content: repeat(
    var(--columns),
    calc(var(--content-width) / var(--columns))
  );

  display: grid;
  grid-template-columns: 1fr var(--content) 1fr;
  gap: 0;

  :where(& > *) {
    grid-column: 2 / -2;
  }
`;

/**
 * Layout Subgrid used to iherit grid columns from nearest
 * <LayoutGrid /> anscestor.
 */
export const LayoutSubgrid = styled.div<{
  'data-content-grid'?: boolean;
  'data-pile'?: boolean;
}>`
  display: grid;
  grid-column: 1 / -1;
  grid-template-columns: subgrid;

  &[data-pile] {
    grid-row: 1 / -1;
  }

  &[data-content-grid] {
    grid-column: 2 / -2;
    grid-template-columns: repeat(var(--columns), 1fr);

    & > * {
      grid-column: 1 / -1;
    }
  }

  [data-content-grid]:where(& > *) {
    grid-column: 1 / -1;
  }

  :where(& > *) {
    grid-column: 2 / -2;
  }
`;

export const LayoutGridCondensed = styled(LayoutGrid)`
  --content-width: min(
    calc(100% - 24px),
    ${({ theme }) => theme.maxWidth.GRID_CONTENT_CONDENSED}
  );
  grid-column: 2 / -2;
`;

export const layoutGridCondensedPadding = generateFluidPxScale(12, 32);
